module.exports = __webpack_public_path__ + "static/media/radar.447418a6.svg";